import {useState} from 'react';
import {TextField,IconButton,InputAdornment} from '@mui/material';
import {DefaultConfig} from '../../../core/utilities/Utilities';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldTextAreaJoin=({rowJoin,application,fieldNameJoin})=>{
    const fieldProp=rowJoin?.[fieldNameJoin];
    const fieldValue=fieldProp?.value;
    const [expanded,setExpanded]=useState(false);

    return (
        <TextField
            inputProps={{maxLength:fieldProp?.ui_max_length,readOnly:true}}
            sx={{div:{backgroundColor:readOnlyBackgroundColor}}}
            multiline={true}
            rows={expanded?10:fieldProp?.ui_rows}
            style={{marginTop:"0px",marginBottom:"8px"}}
            id={fieldNameJoin}
            name={fieldNameJoin}
            type={'text'}
            fullWidth
            required={false}
            variant="outlined"
            size="small"
            label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldNameJoin}
            value={fieldValue||''}
            margin="normal"
            InputProps={{
                endAdornment:(
                    <InputAdornment position="end">
                        <IconButton onClick={()=>setExpanded(!expanded)} edge="end" size="small">{expanded?<ExpandLessIcon/>:<ExpandMoreIcon/>}</IconButton>
                    </InputAdornment>
                )
            }}/>
    );
}

export default FieldTextAreaJoin;
